export default {
  pageTitle: '塔槽製作',
  metaDescription: 'TEFはチタン、ニッケル合金、ステンレス鋼を用いて、石油・ガスおよび石油化学用途向けの蒸留塔・プロセスタワーを製作しています。',
  sidebar: {
    title: '製作品一覧',
    vessel: 'ベッセル製作',
    heatExchanger: '熱交換器製作',
    piping: '配管製作',
    tower: 'タワー製作',
    muffle: 'マッフル製作',
    radiantTube: 'ラジアントチューブ製作',
    otherEquipment: 'その他設備製作',
  },
  fabricationOf: '製作',
  productName: 'タワー',
  description: '以下は、当社のタワー製作における、様々な材質・種類・仕様に関する実績カタログです。',
};
